<template>
  <div>
    <nav class="navbar navbar-expand-lg">
      <router-link id="icon" class="nav-link d-flex" to="/" tag="li" active-class="active" exact>
        <img src="../../assets/jscc-logo.jpg" alt="logo" width="50px" height="50px">
        <p class="pl-3 text-white font-weight-bold logo">Jesus the Saviour Catholic Church</p>
        <p class="pl-1 text-white font-weight-bold logo-second">Jesus the Saviour <br /> Catholic
          Church</p>
      </router-link>


      <button class="navbar-toggler" type="button" data-toggle="collapse" data-target="#navbarNav"
        aria-controls="navbarNav" aria-expanded="false" aria-label="Toggle navigation">
        <span class="navbar-toggler-icon"></span>
      </button>

      <div class="collapse navbar-collapse" id="navbarSupportedContent">

        <ul class="navbar-nav ml-auto nav-wrapper">
          <router-link id="home" class="nav-link" to="/" tag="li" active-class="active" exact>
            Home <span class="sr-only item">(current)</span></router-link>

          <li class="nav-item dropdown item">
            <a class="nav-link dropdown-toggle" href="#" id="navbarDropdown" role="button"
              data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
              About
            </a>

            <div class="dropdown-menu" aria-labelledby="navbarDropdown">
              <router-link id="parish-history" class="nav-link dropdown-item" to="/parish-history"
                tag="li" active-class="active" exact>
                Parish History</router-link>
              <router-link id="pastoral-team" class="nav-link dropdown-item" to="/pastoral-team"
                tag="li" active-class="active" exact>
                Pastoral Team</router-link>
              <!-- <router-link id="ppc" class="nav-link dropdown-item" to="/pastoral-council" tag="li" active-class="active" exact>
                Parish Pastoral Council</router-link> -->
              <router-link id="ppc" class="nav-link dropdown-item" to="/pastoral-activities"
                tag="li" active-class="active" exact>
                Parish Activities</router-link>
            </div>
          </li>

          <!-- <router-link id="parish-activities" class="nav-link" to="/parish-activities" tag="li" active-class="active" exact>
                Parish Activities</router-link> -->


          <li class="nav-item dropdown item">
            <a class="nav-link dropdown-toggle" href="#" id="navbarDropdown" role="button"
              data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
              Book
            </a>
            <div class="dropdown-menu" aria-labelledby="navbarDropdown">
              <router-link id="mass-intention" class="nav-link dropdown-item" to="/" tag="li"
                active-class="active" exact>
                Mass intentions</router-link>
          <li id="thanksgiving" class="nav-link dropdown-item" @click="toggleThanksgivingModal">
            Thanksgiving</li>
      </div>
      </li>

      <li class="nav-item mr-2">
        <button class="btn-jscc-sm">Live Stream</button>
      </li>

      <li class="nav-item">
        <!-- <router-link id="contact" class="nav-link" to="/contact" tag="li" active-class="active" exact>
                Contact</router-link> -->

        <button class="btn-jscc-sm">Give</button>
      </li>
      </ul>

  </div>


  </nav>


  <Thanksgiving v-if="isThanksgiving" @close="toggleThanksgivingModal"></Thanksgiving>
  </div>
</template>

<script>
import Thanksgiving from '@/components/forms/Thanksgiving.vue';
export default {
  data() {
    return {
      isThanksgiving: false,
    }
  },
   components: {
    Thanksgiving
  },
  methods: {
     toggleThanksgivingModal() {
      this.isThanksgiving = !this.isThanksgiving
    },

     closeModal: function () {
      this.$emit('close');
    },

  scrollFunction() {
      //Get header
      let background = document.querySelector(".navigation-header");
      if (document.body.scrollTop > 20 || document.documentElement.scrollTop > 20) {
        background.classList.add('nav-transparent')
      } else {
        background.classList.remove('nav-transparent')
      }
    },

  },

  // created() {
  //   window.addEventListener('scroll', this.scrollFunction);
  // },

  // destroyed() {
  //   window.removeEventListener('scroll', this.scrollFunction);
  // }
}
</script>

<style scoped>

.navigation-header {
  width: 100%;
  display: flex;
  position: fixed;
  z-index: 99;
  transition: all 0.5s ease-out;
}

.navbar {
  background: rgba(7, 3, 26, 0.555);
  /* background: rgba(0, 0, 0, 0.384); */
  width: 100%;
}

.nav-transparent {
  background: rgba(7, 3, 26, 0.75);

}

.item:hover {
  border-bottom: 2px solid red;
}

.navbar a {
  color: #fff;
}

.dropdown-item {
  color: #000 !important;
}

.nav-link {
  cursor: pointer;
  color: #fff;
}

.dropdown-item.active,
.dropdown-item:active {
  color: #fff;
  text-decoration: none;
  background-color: #fff !important;
}

.navbar-toggler {
  background-color: #fff;
}


@media only screen and (min-width:320px) {
  .nav-link {
    padding: 0.3rem 0.2rem;
  }

  .logo {
    font-size: 1.2rem;
    display: none;
  }

  .logo-second {
    font-size: 1rem;
    display: block;
  }
}

/* Extra small devices (phones, 600px and down) */
@media only screen and (max-width: 600px) {
  .nav-link {
    padding: 0.3rem 0.2rem;
  }

  .logo {
    font-size: 1.2rem;
    display: none;
  }

  .logo-second {
    font-size: 1rem;
    display: block;
  }
}

/* Small devices (portrait tablets and large phones, 600px and up) */
@media only screen and (min-width: 600px) {
  .nav-link {
    padding: 0.3rem 0.2rem;
  }

  .logo {
    font-size: 1.2rem;
    display: none;
  }

  .logo-second {
    font-size: 1rem;
    display: block;
  }
}

/* Medium devices (landscape tablets, 768px and up) */
@media only screen and (min-width: 768px) {
  .logo {
    font-size: 1.2rem;
    display: block;
  }

  .logo-second {
    font-size: 1.2rem;
    display: none;
  }
}

  /* Large devices (laptops/desktops, 992px and up) */
  @media only screen and (min-width: 992px) {
    .logo {
      font-size: 1.2rem;
      display: block;
    }

    .logo-second {
      font-size: 1.2rem;
      display: none;
    }
  }

  /* Extra large devices (large laptops and desktops, 1200px and up) */
  @media only screen and (min-width: 1200px) {
    .logo {
      font-size: 1.2rem;
      display: block;
    }

    .logo-second {
      font-size: 1.2rem;
      display: none;
    }
  }

</style>
